import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { RevenueGrowthSystemSection } from "@/components/sections/RevenueGrowthSystemSection";
import { CTASection } from "@/components/sections/CTASection";

const RevenueSystem = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-20">
        <RevenueGrowthSystemSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default RevenueSystem;
